import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['Carlos', 'María', 'Juan', 'Ana', 'Pedro', 'Laura', 'Diego', 'Sofía', 'Miguel', 'Valentina', 'Luciana', 'Martín', 'Camila', 'Nicolás', 'Florencia'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Miguel de Tucumán'];
function randomAge() {
  return Math.floor(Math.random() * (55 - 25 + 1) + 25);
}
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: '',
    age: 0
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentBuyer({
        name: randomName,
        city: randomCity,
        age: randomAge()
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimer = setTimeout(showPopup, 5000);
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.floor(Math.random() * (30000 - 15000 + 1) + 15000));
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-256">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white border border-[#E8D5C4] rounded-xl p-3 shadow-2xl flex items-center gap-3 max-w-sm" data-id="element-257">
          <img src="https://cdn.magicpatterns.com/uploads/njMAY3XguUNyW1FQwxsdek/0_cover_1.png" alt="Libro de Budines" className="w-14 h-14 object-cover rounded-lg flex-shrink-0" data-id="element-258" />
          <div data-id="element-259">
            <p className="text-sm text-[#6B5344]" data-id="element-260">
              <strong className="text-[#3D2B1F]" data-id="element-261">{currentBuyer.name}</strong>,{' '}
              {currentBuyer.age} años — {currentBuyer.city}
            </p>
            <p className="text-xs text-[#D4850A] font-medium mt-1" data-id="element-262">
              Acaba de comprar este producto
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}